module.exports = __webpack_public_path__ + "assets/img/Security.64df1256.svg";